import { compose, lifecycle, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import { pickBy } from 'lodash';
import { bindActionCreators } from 'redux';
import moment from 'moment-timezone';

import {
  getActiveDayTimes,
  getActiveTime,
  getDays,
  getNextLink,
  getNextUnfetchedDay,
  getNoTimesAvailable,
  shouldLoadTimesForInterval,
} from '../../times/selectors';
import {
  clearBarberAvailability,
  fetchShopAvailability,
  setActiveDay,
  setActiveTime,
} from '../../times/actions';
import PickTime from './components/PickTime';
import { fetchShop } from '../../shops/actions';
import { getShopTimezone, getShopId } from '../../shops/selectors';
import { generateUrlString, nullFunc } from '../../utils/helpers';
import config from '../../../config';
import { ANY_SERVICE } from '../../constants';

const shouldFetchNextUnfetchedDay = (props, nextDay) => {
  if (props.isFetching) return false;
  if (moment(props.nextUnfetchedDay).week() - moment(nextDay || props.activeDay).week() > 1) return false;
  return props.shouldLoadTimesForInterval(props.nextUnfetchedDay);
};

const fetchData = lifecycle({
  componentDidMount() {
    this.props.clearBarberAvailability();
    this.props.fetchShop()
      .then(() => this.props.fetchAvailability(moment()))
      .catch(nullFunc);
  },

  componentDidUpdate() {
    if (shouldFetchNextUnfetchedDay(this.props)) {
      this.props.fetchAvailability(moment(this.props.nextUnfetchedDay));
    }
  },
});

const slideChangeHandlers = withHandlers({
  onDateSliderBeforeChange: props => (previousIndex, nextIndex) => {
    const nextDay = moment().add(nextIndex, 'days');
    if (nextIndex > previousIndex && shouldFetchNextUnfetchedDay(props, nextDay)) {
      props.fetchAvailability(props.nextUnfetchedDay);
    }
  },

  onDateSliderAfterChange: props => (index) => {
    const weekDay = moment(props.activeDay).day();
    const activeDay = moment().add(index, 'days').day(weekDay).format(config.apiDateFormat);

    props.setActiveDay(activeDay);
  },
});

const selectedTimeUrlState = compose(
  connect((state, ownProps) => ({
    selectedTime: getActiveTime(state),
    nextLink: getNextLink(state, ownProps.generateUrlString),
  }), { setSelectedTime: setActiveTime }),
  withHandlers({
    setTime: props => item => () => {
      const reservationTime = moment(item.time).format(config.timeSlugFormat);
      props.setSelectedTime(reservationTime);
    },
  })
);

const mapStateToProps = (state, ownProps) => {
  const timezone = getShopTimezone(state, ownProps.params.shopRoute);

  return {
    shopId: getShopId(state, ownProps.params.shopRoute),
    serviceId: ANY_SERVICE,
    activeDay: state.times.activeDay,
    times: getActiveDayTimes(state, timezone),
    noTimesAvailable: getNoTimesAvailable(state),
    days: getDays(state),
    shouldLoadTimesForInterval: shouldLoadTimesForInterval.bind(null, state),
    nextUnfetchedDay: getNextUnfetchedDay(state),
    isFetching: state.times.get('isFetching'),
    timezone,
    generateUrlString: params => generateUrlString({
      shopRoute: ownProps.params.shopRoute,
      ...pickBy(params),
    }, ownProps.urlPattern),
  };
};

const mapDispatchToProps = (dispatch, ownProps) => bindActionCreators({
  fetchShop: fetchShop.bind(null, ownProps.params.shopRoute, ownProps.urlPattern),
  fetchAvailability: fetchShopAvailability.bind(null, ownProps.params.shopRoute),
  clearBarberAvailability,
  setActiveDay,
}, dispatch);

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  fetchData,
  selectedTimeUrlState,
  slideChangeHandlers,
)(PickTime);



// WEBPACK FOOTER //
// ./src/app/dynamicBooking/time/PickTime.js